export { default as getRouteFromCategory }from "./getRouteFromCategory";

